import { PropsWithChildren } from 'react';
import { SidebarDivider, SidebarItem } from '@backstage/core-components';
import { FeatureFlagged } from '@backstage/core-app-api';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import MapIcon from '@material-ui/icons/MyLocation';
import PolicyIcon from '@material-ui/icons/Policy';
import { Root as DefaultRoot } from '@platt-internal/backstage-plugin-bootstrap-react';
import { FaqsSidebarItems } from '@platt/backstage-plugin-bootstrap-faqs-react';
import { isAzurePolicyEnabled } from '@platt/backstage-plugin-az-policy';

const AzurePolicy = () => {
  const config = useApi(configApiRef);
  if (!isAzurePolicyEnabled(config)) {
    return <></>;
  }
  // enable azure policy menu item
  return (
    <FeatureFlagged with="az-policy-enabled">
      <SidebarItem icon={PolicyIcon} to="az-policy" text="Azure Policy" />
    </FeatureFlagged>
  );
};

const additionalMenuItems = (
  <>
    <FaqsSidebarItems />
    <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
    <AzurePolicy />
    <SidebarDivider />
  </>
);

export const Root = ({ children }: PropsWithChildren<{}>) => {
  return (
    <DefaultRoot additionalMenuItems={additionalMenuItems}>
      {children}
    </DefaultRoot>
  );
};
